import { CdkDragMove } from '@angular/cdk/drag-drop';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Inject, Input, OnInit, Renderer2, SimpleChanges ,ElementRef, NgZone, ViewChild, Injector, Output, EventEmitter } from '@angular/core';
import { MeetingResponse } from 'src/app/models/basicMeetingModel';
import { Globals } from 'src/app/service/global';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { environment } from 'src/environments/environment';
// import {NgxResizeHandleType} from 'ngx-drag-resize';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { AgoraConfigService } from 'src/AgoraConfigService';

@Component({
  selector: 'app-video-box',
  templateUrl: './video-box.component.html',
  styleUrls: ['./video-box.component.css']
})
export class VideoBoxComponent implements OnInit {
  width : any;
  height : any
  @Input() dragEnabled : any;
  @Input() pinDialog : any
  @Input() meetingResponse!: MeetingResponse;
  userEmail : string ="ppraveen549@gmail.com";
  role:any;
  agoraConfigObject: any;
  // readonly handleType = NgxResizeHandleType;

  
  constructor(private injector:Injector, private renderer : Renderer2,public httpClient: HttpClient, public sideNav : SideNavServiceService,private globals:Globals, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
   }

  ngOnInit(): void {
    $('#zoomIframe')?.attr('src', `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.zoomURL}`+'?zoomMeetingId='+this.meetingResponse.zoomMeetingId+'&zoomPassword='+this.meetingResponse.zoomPassword+'&userName='+localStorage.getItem('userName')+'&userEmail='+localStorage.getItem('email')+'&agoraMeetingId='+this.meetingResponse.meetingId+'&userId='+localStorage.getItem("userId"))
    
    //$('#zoomIframe')?.attr('src', `${environment.zoomURL}`+'?zoomMeetingId='+this.meetingResponse.zoomMeetingId+'&zoomPassword='+this.meetingResponse.zoomPassword+'&userName='+localStorage.getItem('userName')+'&userEmail='+localStorage.getItem('email')+'&zoomSecretId='+this.globals.settingValuesList.ZOOM_SDK_SECRET_ID+'&zoomSecretKey='+this.globals.settingValuesList.ZOOM_SDK_SECRET_KEY+'&zoomJwtSecretId='+this.globals.settingValuesList.ZOOM_JWT_SECRET_ID+'&zoomJwtApiKey='+this.globals.settingValuesList.ZOOM_JWT_API_KEY);
  }

  ngOnChanges(changes : SimpleChanges){
     
      if(this.meetingResponse.facilitatorId!=null && (this.meetingResponse.facilitatorId.toString()==localStorage.getItem("userId"))){
          this.role=1;
      }else{
        this.role=0;
      }
      if(document.getElementById('zoomIframe')?.getAttribute('src')){
        setTimeout(() => {
          $('#zoomIframe')?.attr('src', `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.zoomURL}`+'?zoomMeetingId='+this.meetingResponse.zoomMeetingId+'&agoraUserId='+localStorage.getItem('userId')+'&zoomPassword='+this.meetingResponse.zoomPassword+'&userName='+localStorage.getItem('userName')+'&userrole='+this.role+'&agoraMeetingId='+this.meetingResponse.meetingId);
          //$('#zoomIframe')?.attr('src', `${environment.zoomURL}`+'?zoomMeetingId='+this.meetingResponse.zoomMeetingId+'&zoomPassword='+this.meetingResponse.zoomPassword+'&userName='+localStorage.getItem('userName')+'&userEmail='+localStorage.getItem('email')+'&zoomSecretId='+this.globals.settingValuesList.ZOOM_SDK_SECRET_ID+'&zoomSecretKey='+this.globals.settingValuesList.ZOOM_SDK_SECRET_KEY+'&zoomJwtSecretId='+this.globals.settingValuesList.ZOOM_JWT_SECRET_ID+'&zoomJwtApiKey='+this.globals.settingValuesList.ZOOM_JWT_API_KEY);
        },600)
      }
  }

  ngAfterViewInit(){
    this.renderer.listen(document.getElementById('video-func'), 'drag', () => {
      window.alert('triggered')
    })
  }

  // ngAfterViewInit(){  
  //   $('#zoomIframe')?.attr('src', `${environment.zoomURL}`+'?zoomMeetingId='+this.meetingResponse.zoomMeetingId+'&zoomPassword='+this.meetingResponse.zoomPassword+'&userName='+localStorage.getItem('userName')+'&userEmail='+localStorage.getItem('email')+'&zoomSecretId='+this.globals.settingValuesList.ZOOM_SDK_SECRET_ID+'&zoomSecretKey='+this.globals.settingValuesList.ZOOM_SDK_SECRET_KEY+'&zoomJwtSecretId='+this.globals.settingValuesList.ZOOM_JWT_SECRET_ID+'&zoomJwtApiKey='+this.globals.settingValuesList.ZOOM_JWT_API_KEY);
  
  // }
  // ngOnChanges(changes: SimpleChanges) {
  
  //   // changes.prop contains the old and the new value...
  //   if(!changes?.pinDialog?.currentValue){
  //       $('#zoomIframe')?.attr('src', `${environment.zoomURL}`+'?zoomMeetingId='+this.meetingResponse.zoomMeetingId+'&zoomPassword='+this.meetingResponse.zoomPassword+'&userName='+localStorage.getItem('userName')+'&userEmail='+localStorage.getItem('email')+'&zoomSecretId='+this.globals.settingValuesList.ZOOM_SDK_SECRET_ID+'&zoomSecretKey='+this.globals.settingValuesList.ZOOM_SDK_SECRET_KEY+'&zoomJwtSecretId='+this.globals.settingValuesList.ZOOM_JWT_SECRET_ID+'&zoomJwtApiKey='+this.globals.settingValuesList.ZOOM_JWT_API_KEY);
  
  //   }
  // }



  // ngOnChanges(){
    
  // }


}
